import { useFeatureFlag } from '@order/LaunchDarkly';

/**
 * Returns scan to pay feature flag value to enable/disable certain features.
 */
export const useScanToPayFeatureFlag = () => {
  return useFeatureFlag('permanent-scan-to-pay-enabled');
};

/**
 * Enables listening to shake events for scan to pay.
 */
export const useScanToPayShakeListenerFeatureFlag = () => {
  return useFeatureFlag('permanent-scan-to-pay-shake-listener-enabled');
};
